import { useEffect, useState } from "react";
import { LuFacebook } from "react-icons/lu";
import { doc, collection, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";

export default function FacebookFloatButton() {
    const [facebookLink, setFacebookLink] = useState("");

    useEffect(() => {
        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setFacebookLink(docSnap.data().facebook_link);
            }
        });
    }, []);

    if (!facebookLink) return null;

    return (
        <a
            href={facebookLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed z-50 bottom-24 right-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg p-4 flex items-center justify-center transition-all"
            aria-label="Visite nosso Facebook"
            style={{ boxShadow: "0 4px 16px rgba(0,0,0,0.2)" }}
        >
            <LuFacebook className="text-3xl" />
        </a>
    );
}